export const TOGGLE_ACTIVE_STORE_TAB = "TOGGLE_ACTIVE_STORE_TAB";
export const RESET_ACTIVE_STORE_TAB = "RESET_ACTIVE_STORE_TAB";

export const OPEN_MANAGE_MENU = "OPEN_MANAGE_MENU";
export const CLOSE_MANAGE_MENU = "CLOSE_MANAGE_MENU";

export const TOGGLE_CATEGORIES_MENU = "TOGGLE_CATEGORIES_MENU";
export const CLOSE_CATEGORIES_MENU = "CLOSE_CATEGORIES_MENU";
